export default "__VITE_ASSET__BjkKv38a__"